// FIXME: In progress. Rebuilding to separated player & recorder

import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  Text,
  ActivityIndicator,
} from "react-native";
import { colors } from "src/assets";
import Slider from "@react-native-community/slider";
// import { AudioRecorder, useAudioRecorder } from "react-audio-voice-recorder";
import LocalText from "src/local";
import alert from "src/components/alert";

const RecordIcon: React.FC = () => {
  return (
    <svg fill="#FF0000" viewBox="0 0 48 48" width="24px" height="24px">
      <path d="M 23.919922 4 C 12.873922 4 3.9199219 12.954 3.9199219 24 C 3.9199219 35.046 12.873922 44 23.919922 44 C 34.965922 44 43.919922 35.046 43.919922 24 C 43.919922 12.954 34.965922 4 23.919922 4 z" />
    </svg>
  );
};

const PlayIcon: React.FC = () => {
  return (
    <svg fill="#FF0000" viewBox="0 0 24 24" width="24px" height="24px">
      <path d="M8,6.822v10.357c0,0.789,0.871,1.267,1.537,0.844l8.137-5.178c0.618-0.393,0.618-1.294,0-1.687L9.537,5.978 C8.871,5.554,8,6.033,8,6.822z" />
    </svg>
  );
};

const StopIcon: React.FC = () => {
  return (
    <svg fill="#FF0000" viewBox="0 0 24 24" width="24px" height="24px">
      <path d="M17,19H7c-1.105,0-2-0.895-2-2V7c0-1.105,0.895-2,2-2h10c1.105,0,2,0.895,2,2v10C19,18.105,18.105,19,17,19z" />
    </svg>
  );
};

const TrashIcon: React.FC = () => {
  return (
    <svg fill="#FF0000" viewBox="0 0 24 24" width="24px" height="24px">
      <path d="M 10 2 L 9 3 L 5 3 C 4.448 3 4 3.448 4 4 C 4 4.552 4.448 5 5 5 L 7 5 L 17 5 L 19 5 C 19.552 5 20 4.552 20 4 C 20 3.448 19.552 3 19 3 L 15 3 L 14 2 L 10 2 z M 5 7 L 5 20 C 5 21.105 5.895 22 7 22 L 17 22 C 18.105 22 19 21.105 19 20 L 19 7 L 5 7 z" />
    </svg>
  );
};

export enum SoundPlayerStatus {
  Playing,
  Stopped,
  Unknown,
}
export enum SoundRecoredStatus {
  Recording,
  Recorded,
  Stopped,
  Unknown,
}

export enum SoundRecoredVariant {
  Player,
  Recorder,
}

export type SoundRecorderProps = {
  source?: string;
  variant: SoundRecoredVariant;
  loading?: boolean;
  onChange?: (file?: string) => void;
};

const MAX_RECORD_TIME_SEC = 30;
let recorderInterval: any;

export const SoundRecorder: React.FC<SoundRecorderProps> = ({
  source,
  variant,
  loading,
  onChange,
}) => {
  // const recorderControls = useAudioRecorder();
  const audioRef = useRef<HTMLAudioElement>(null);
  const [playerStatus, setPlayerStatus] = useState<SoundPlayerStatus>(
    SoundPlayerStatus.Unknown
  );
  const [recoredStatus, setRecoredStatus] = useState<SoundRecoredStatus>(
    variant === SoundRecoredVariant.Recorder && source
      ? SoundRecoredStatus.Recorded
      : SoundRecoredStatus.Unknown
  );
  const [recordedSource, setRecordedSource] = useState<string | undefined>(
    source
  );
  useEffect(() => {
    setRecordedSource(source);
  }, [source]);
  const [recordedDuration, setRecordedDuration] = useState<number>(0);
  const [playedPosition, setPlayedPosition] = useState<number>(0);
  const [isPlayerLoading, setIsPlayerLoading] = useState<boolean>(false);
  const startPlaying = useCallback(async () => {
    setIsPlayerLoading(true);
    audioRef.current?.play().then((e) => {
      setIsPlayerLoading(false);
      setRecordedDuration(audioRef.current?.currentTime || 0);
    });
  }, []);
  const stopPlaying = useCallback(async () => {
    const audio = audioRef.current;
    if (audio) {
      audio.pause();
      audio.currentTime = 0;
    }
    setPlayedPosition(0);
  }, []);
  const startRecording = useCallback(async () => {
    try {
      // recorderControls.startRecording();
      setRecordedDuration(0);
      let startTime = Date.now();

      recorderInterval = setInterval(() => {
        const time = (Date.now() - startTime) / 1000;
        if (time >= MAX_RECORD_TIME_SEC) {
          stopRecording();
        } else {
          setRecordedDuration(Math.max(Math.round(time), 0));
        }
      }, 500);
    } catch (e) {
      console.error(e);
      setRecoredStatus(SoundRecoredStatus.Stopped);
    }
  }, []);
  const stopRecording = useCallback(async () => {
    // recorderControls.stopRecording();
    clearInterval(recorderInterval);
  }, [recordedSource, source]);
  useEffect(() => {
    setRecoredStatus(
      variant === SoundRecoredVariant.Recorder && source
        ? SoundRecoredStatus.Recorded
        : SoundRecoredStatus.Unknown
    );
    setRecordedSource(source);
  }, [variant, source]);
  useEffect(() => {
    if (playerStatus === SoundPlayerStatus.Stopped) {
      stopPlaying();
    } else if (playerStatus === SoundPlayerStatus.Playing) {
      startPlaying();
    }
  }, [playerStatus]);
  useEffect(() => {
    if (recoredStatus === SoundRecoredStatus.Stopped) {
      setRecordedDuration(0);
      setRecordedSource(undefined);
    } else if (recoredStatus === SoundRecoredStatus.Recorded) {
      stopRecording();
    } else if (recoredStatus === SoundRecoredStatus.Recording) {
      startRecording();
    }
  }, [recoredStatus]);

  return (
    <View style={[styles.root]}>
      <View style={{ display: "none" }}>
        {/* <AudioRecorder
          onRecordingComplete={(blob:) => {
            const url = URL.createObjectURL(blob);
            setRecordedSource(url);
            if (onChange) {
              onChange(url);
            }
          }}
          recorderControls={recorderControls}
        /> */}
        {recordedSource && (
          <audio
            ref={audioRef}
            onLoadedMetadata={(e) => {
              // const audio = audioRef.current;
              // if (!audio) return;
              // if (audio.duration === Infinity) {
              //   audio.currentTime = 1e101;
              // }
              // setRecordedDuration(audioRef.current?.duration || 0);
            }}
            onPause={() => setPlayerStatus(SoundPlayerStatus.Stopped)}
            onTimeUpdate={(e) => {
              // const audio = audioRef.current;
              // if (audio) {
              //   console.log("audio.currentTime", audio.currentTime);
              //   console.log("audio.played", audio.played);
              //   if (audio.played.length === 0) {
              //     // audio.currentTime = 0;
              //     // setPlayedPosition(audio.currentTime || 0);
              //     // setRecordedDuration(audio.duration);
              //     // console.log("audio.duration", audio.duration);
              //   } else {
              //     setPlayedPosition(audio.currentTime || 0);
              //   }
              // }
            }}
            controls
          >
            <source src={recordedSource} type="audio/wav"></source>
          </audio>
        )}
      </View>
      {variant === SoundRecoredVariant.Recorder &&
        recoredStatus === SoundRecoredStatus.Recorded &&
        playerStatus !== SoundPlayerStatus.Playing &&
        !isPlayerLoading &&
        !loading && (
          <TouchableOpacity
            style={styles.btnSmall}
            onPress={() => {
              alert(
                LocalText.components.soundRecorder.deleteAlert.title,
                undefined,
                [
                  {
                    text: LocalText.common.yes,
                    style: "destructive",
                    onPress: async () => {
                      setRecoredStatus(SoundRecoredStatus.Stopped);
                      if (onChange) {
                        onChange();
                      }
                    },
                  },
                  { text: LocalText.common.no, style: "cancel" },
                ],
                { cancelable: false }
              );
            }}
          >
            <TrashIcon />
          </TouchableOpacity>
        )}
      {playerStatus === SoundPlayerStatus.Playing && !isPlayerLoading && (
        <TouchableOpacity
          style={styles.btn}
          onPress={() => setPlayerStatus(SoundPlayerStatus.Stopped)}
        >
          <StopIcon />
        </TouchableOpacity>
      )}
      {playerStatus === SoundPlayerStatus.Playing && isPlayerLoading && (
        <View style={styles.btn}>
          <ActivityIndicator />
        </View>
      )}
      {(variant === SoundRecoredVariant.Player ||
        recoredStatus === SoundRecoredStatus.Recorded) &&
        (playerStatus === SoundPlayerStatus.Stopped ||
          playerStatus === SoundPlayerStatus.Unknown) &&
        !loading && (
          <TouchableOpacity
            style={styles.btn}
            onPress={() => setPlayerStatus(SoundPlayerStatus.Playing)}
          >
            <PlayIcon />
          </TouchableOpacity>
        )}
      {(variant === SoundRecoredVariant.Player ||
        recoredStatus === SoundRecoredStatus.Recorded) &&
        (playerStatus === SoundPlayerStatus.Stopped ||
          playerStatus === SoundPlayerStatus.Unknown) &&
        loading && (
          <View style={styles.btn}>
            <ActivityIndicator />
          </View>
        )}
      {recoredStatus === SoundRecoredStatus.Recording && (
        <TouchableOpacity
          style={styles.btn}
          onPress={() => {
            setRecoredStatus(SoundRecoredStatus.Recorded);
          }}
        >
          <StopIcon />
        </TouchableOpacity>
      )}
      {variant === SoundRecoredVariant.Recorder &&
        (recoredStatus === SoundRecoredStatus.Stopped ||
          recoredStatus === SoundRecoredStatus.Unknown) && (
          <TouchableOpacity
            style={styles.btn}
            onPress={() => setRecoredStatus(SoundRecoredStatus.Recording)}
          >
            <RecordIcon />
          </TouchableOpacity>
        )}

      {recoredStatus === SoundRecoredStatus.Recording ||
      (recoredStatus === SoundRecoredStatus.Unknown &&
        playerStatus === SoundPlayerStatus.Unknown &&
        !recordedSource) ? (
        <View style={styles.sliderRoot}>
          <Text>0秒</Text>
          <Slider
            style={styles.slider}
            minimumValue={0}
            maximumValue={MAX_RECORD_TIME_SEC}
            minimumTrackTintColor="#BFBFBF"
            maximumTrackTintColor="#BFBFBF"
            value={recordedDuration}
          />
          <Text>30秒</Text>
        </View>
      ) : (
        <View style={styles.sliderRoot}>
          <Text>0秒</Text>
          <Slider
            style={styles.slider}
            minimumValue={0}
            maximumValue={recordedDuration}
            minimumTrackTintColor="#BFBFBF"
            maximumTrackTintColor="#BFBFBF"
            value={playedPosition}
          />
          <Text>
            {Math.round(recordedDuration) > 0
              ? Math.round(recordedDuration)
              : MAX_RECORD_TIME_SEC}
            秒
          </Text>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    backgroundColor: colors.white,
    paddingVertical: 20,
    paddingHorizontal: 16,

    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  btn: {
    width: 64,
    height: 64,
    padding: 20,
    borderColor: "#707070",
    borderWidth: 2,
    borderRadius: 32,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  btnSmall: {
    width: 32,
    height: 32,
    padding: 10,
    marginRight: 8,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  sliderRoot: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    marginLeft: 20,
  },
  slider: {
    flex: 1,
    marginHorizontal: 10,
  },
});
